export const GLOW_PATH = "/pacchetto-glow-regalo-catanzaro";

// Natale: dal 15 ottobre al 6 gennaio · San Valentino: dal 7 gennaio al 14 febbraio
export const getSeason = (d = new Date()) => {
  const m = d.getMonth() + 1;
  const day = d.getDate();
  if ((m === 10 && day >= 15) || m === 11 || m === 12 || (m === 1 && day <= 6)) return "xmas";
  if (m === 1 || (m === 2 && day <= 14)) return "valentine";
  return null;
};

export const SEASON_COPY = {
  xmas: {
    it: { tag: "Natale da Gioia", text: "Regala il Pacchetto Glow: Mesoporazione + crema alla vitamina C", cta: "Scopri il regalo", gifts: "Buoni regalo", occasion: "Natale" },
    en: { tag: "Christmas at Gioia", text: "Give the Glow Package: Mesoporation + vitamin C cream", cta: "Discover the gift", gifts: "Gift cards", occasion: "Christmas" },
  },
  valentine: {
    it: { tag: "San Valentino da Gioia", text: "Il regalo per lei: Pacchetto Glow con Mesoporazione + crema alla vitamina C", cta: "Scopri il regalo", gifts: "Buoni regalo", occasion: "San Valentino" },
    en: { tag: "Valentine's at Gioia", text: "The gift for her: Glow Package with Mesoporation + vitamin C cream", cta: "Discover the gift", gifts: "Gift cards", occasion: "Valentine's Day" },
  },
};
